const featuredPicks = [
  {
    name: 'Trending Sneakers',
    price: 'From $49.99',
    badge: 'Best Seller',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20athletic%20sneakers%20in%20warm%20sand%20and%20clay%20colorways%20displayed%20on%20a%20minimalist%20floating%20shelf%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20lifestyle%20product%20photography%20with%20clean%20cream%20wall%20backdrop%2C%20modern%20sneakerhead%20aesthetic%20with%20refined%20composition&width=800&height=600&seq=fp-v3-sneakers&orientation=landscape',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    name: 'Cozy Hoodies',
    price: 'From $39.99',
    badge: 'Popular',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20brushed%20cotton%20hoodies%20in%20oatmeal%20and%20taupe%20tones%20draped%20over%20a%20midcentury%20armchair%2C%20warm%20afternoon%20light%20through%20sheer%20curtains%2C%20cozy%20home%20editorial%20photography%20with%20textured%20throw%20pillows%2C%20inviting%20comfort%20aesthetic&width=800&height=600&seq=fp-v3-hoodies&orientation=landscape',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
  },
  {
    name: 'Premium Jackets',
    price: 'From $79.99',
    badge: 'New Arrival',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20bomber%20and%20utility%20jackets%20in%20olive%20and%20camel%20displayed%20on%20a%20minimalist%20walnut%20coat%20stand%2C%20soft%20gallery%20lighting%20creating%20depth%2C%20contemporary%20fashion%20editorial%20with%20textured%20plaster%20wall%20backdrop%2C%20sophisticated%20urban%20style&width=800&height=600&seq=fp-v3-jackets&orientation=landscape',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
  },
];

export default function FeaturedPicks() {
  return (
    <section className="w-full py-14 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Featured Picks
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md">
            Handpicked favorites from our <strong>LitBuy spreadsheet</strong> collection. Updated weekly with the best finds.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredPicks.map((item, idx) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-all duration-300"
            >
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`${item.name} - Featured LitBuy Spreadsheet Pick`}
                  title={`${item.name} via LitBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.name}
                  </h3>
                  <span className={`text-xs px-2.5 py-1 rounded-full whitespace-nowrap ${
                    idx === 0
                      ? 'bg-accent-100 text-accent-700'
                      : idx === 1
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}>
                    {item.badge}
                  </span>
                </div>
                <p className="text-lg md:text-xl font-bold text-foreground-900">
                  {item.price}
                </p>
                <div className="mt-4">
                  <span className={`inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    idx === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'border-2 border-foreground-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500'
                  }`}>
                    {idx === 0 ? 'View Deals' : idx === 1 ? 'Compare Prices' : 'New Arrivals'}
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}